// extracted by mini-css-extract-plugin
export default {"tabletImg":"pH","desktopImg":"qH","mobileImg":"rH","backgroundImage":"sH","content":"tH","rtbLeft":"uH","rtbRight":"vH","imageContainer":"wH","rtbBox":"xH","line":"yH","rtbLeftMobile":"zH","rtbDesktop":"AH"};
    if(module.hot) {
      // 1715091679791
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  